package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class FindReceivedInvitationsUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(): Result<List<Invitation>> = invitationService.findReceivedInvitations()
}
